<template>
    <page>
        <div class="shadow-25" v-if="mockData">
            <v-header :title="$metaInfo.title" :icon="$route.name === 'remote-coach.reservation' ? 'book' : 'note add'"/>
            <card width="100%">
                <order-stepper v-if="enable_phone_validation" :mockData="mockData"></order-stepper>
                <order-form v-else :mockData="mockData"></order-form>
            </card>
        </div>
        <div class="row justify-center items-center row-spinner-height" v-else>
            <spinner-iqos size="60px"/>
        </div>
    </page>
</template>

<script>
    import axios from 'axios'
    import {
        QSpinnerPuff,
        QSlideTransition
    } from 'quasar-framework'
    import OrderForm from "./orderForm"
    import PhoneValidation from "./phoneValidation"
    import OrderStepper from "./orderStepper"

    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$route.name === 'remote-coach.reservation' ? this.$T('create a new reservation') : this.$T('create a new lending order') }
        },

        components: {
            OrderStepper,
            PhoneValidation,
            OrderForm,
            QSpinnerPuff,
            QSlideTransition
        },

        data() {
            return {
                mockData: null,
                enable_phone_validation: false
            }
        },

        methods: {
            async setup() {
                await this.getMockData()
            },
            /**
             * Loads the "mock data" from the store
             */
            async getMockData() {
                const {data} = await axios.get(`${config.appUrl}/api/v1/lending-point/order/form-mock-data`)
                this.mockData = data.data
                this.enable_phone_validation = this.mockData.enablePhoneValidation
            }
        },

        mounted() {
            this.setup()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/markets/AD/pages/lending-point/order.vue